export const DS_LIGHT_BOX_CLASSES = {
  Root: "ds-light-box",
  FocusBoundary: "ds-light-box__focus-boundary",
  Header: "ds-light-box__header",
  Actions: "ds-light-box__actions",
  Title: "ds-light-box__title",
  Close: "ds-light-box__close",
  Viewport: "ds-light-box__viewport",
  PlayerViewport: "ds-light-box__viewport--player",
  Content: "ds-light-box__content",
  Media: "ds-light-box__media",
  Audio: "ds-light-box__audio",
  Artwork: "ds-light-box__artwork",
  ArtworkImage: "ds-light-box__artwork-image",
  Play: "ds-light-box__play",
  Previous: "ds-light-box__previous",
  Next: "ds-light-box__next",
  Description: "ds-light-box__description",
  DescriptionIcon: "ds-light-box__description-icon",
} as const;
